import React from 'react'

const HomeBody = () => {

  return (
    <div className='home-body'>
        <div className="top-body">
            <h1>Welcome to <span>Connect</span>BlueLoop</h1>
            <p>ConnectBlueLoop is a normal Web Application build by the BlueLoop’s Developers in order to make the connection between you guys and the BlueLoop admins more easier and smoother!</p>
        </div>
        <div className="content">
            <div className='how-to-use'>
                <p>To know about our works in Web Development Sector inside BlueLoop,<br /> <span>Click the Web-Dev Sector Button</span></p>
                <p>To know about our works in Artificial Intelligent Sector inside BlueLoop,<br /> <span>Click the A.I Sector Button</span></p>
                <p>To know about the Vision, Mission, Future Goals and BlueLoop,<br /> <span>Click the About Button</span></p>
                <p>To know about our recent news related to BlueLoop, <br /> <span>Click the NewsFeeds Button</span></p>
            </div>
        </div>
            
    </div>
    
  )

}
export default HomeBody